import { DateTime } from 'luxon';

import { Clock } from '@shared/assets';

import * as st from './index.module.scss';

const Time = ({ date }) => {
	return (
		<div className={st.time}>
			<div className={st.time__icon}>
				<Clock />
			</div>
			<span className={st.time__text}>{DateTime.fromISO(date).toFormat('HH:mm')}</span>
		</div>
	);
};

export default Time;
